var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import kitFetch from '../kit-fetch/kit-fetch';

export var USERDATA_REQUESTED = 'userdata/requested';
export var USERDATA_RECEIVED = 'userdata/received';
export var USERDATA_FAILED = 'userdata/failed';

export var fetchUserdataPromise = function fetchUserdataPromise(dispatch) {
    dispatch(requestUserdata());
    return kitFetch('/authz/authorize/userData');
};

export var requestUserdata = function requestUserdata() {
    return {
        type: USERDATA_REQUESTED
    };
};

export var receiveUserdata = function receiveUserdata(userdata, museums, apps) {
    return {
        type: USERDATA_RECEIVED,
        userdata: {
            name: userdata.name,
            uniqueId: userdata.uniqueId,
            imageUrl: userdata.imageUrl,
            initials: userdata.initials,
            email: userdata.email,
            theme: {
                primaryColor: "#d94353",
                lightColor: "#ee7e8f",
                darkColor: "#ae3552"
            }
        },
        apps: userdata.appAccess.apps.map(function (app) {
            return _extends({}, app, {
                title: apps[app.id].title,
                url: apps[app.id].url,
                icon: apps[app.id].icon_url ? null : apps[app.id].icon,
                imageUrl: apps[app.id].icon_url,
                theme: {
                    primaryColor: apps[app.id].theme.primary_color,
                    lightColor: apps[app.id].theme.light_color,
                    darkColor: apps[app.id].theme.dark_color
                }
            });
        }),
        museums: userdata.appAccess.museums.map(function (museum) {
            return {
                title: museums[museum.id] ? museums[museum.id].name : 'Museum name missing',
                uniqueId: museum.id.toString(),
                imageUrl: 'https://' + museums[museum.id].media,
                media: museums[museum.id].media,
                name: museums[museum.id] ? museums[museum.id].name : 'N/A',
                abbr: museums[museum.id].short_name || 'N/A',
                createdAt: museums[museum.id].created,
                url: '/?museum_id=' + museum.id.toString(),
                theme: {
                    primaryColor: museums[museum.id].primary_color || "#d94353",
                    lightColor: museums[museum.id].light_color || "#ee7e8f",
                    darkColor: museums[museum.id].dark_color || "#ae3552"
                },
                apps: museum.applications.map(function (app) {
                    return _extends({}, app, {
                        title: apps[app.id].title,
                        url: apps[app.id].url + '?museum_id=' + museum.id,
                        icon: apps[app.id].icon_url ? null : apps[app.id].icon,
                        imageUrl: apps[app.id].icon_url,
                        theme: {
                            primaryColor: apps[app.id].theme.primary_color,
                            lightColor: apps[app.id].theme.light_color,
                            darkColor: apps[app.id].theme.dark_color
                        }
                    });
                }),
                type: museums[museum.id].type
            };
        })
    };
};

export var resetUserdata = function resetUserdata() {
    return {
        type: USERDATA_FAILED,
        userdata: {},
        apps: [],
        museums: []
    };
};